import axios, { AxiosRequestConfig } from "axios";
import qs from "qs";
import Config from "../config";
import moment from "moment";
import Storage from "../utils/Storage";
import _ from "underscore";
import PlvVideoUpload from "@polyv/vod-upload-js-sdk";

import { CourseWareTypeList } from "../utils/common";

axios.defaults.baseURL = Config.BaseUrl;

const RequestInterceptor = (config: AxiosRequestConfig) => {
    const batch = Storage.get("batch") || Config.DefaultBatch;
    const token = getToken();
    config.headers = JSON.parse(JSON.stringify(config.headers)); // 为了去除headers里的undefined值
    config.headers = { batchNo: batch, token, ...config.headers };
    return config;
};

const ResponseInterceptor = (error: any) => {
    if (error.response && error.response.status === 401)
        window.location.href = "/login";
    return Promise.reject(error);
};

axios.interceptors.request.use(RequestInterceptor, error => {
    return Promise.reject(error);
});

axios.interceptors.response.use(response => response, ResponseInterceptor);

export const MainRequest = axios.create({ baseURL: Config.BaseUrl });

MainRequest.interceptors.request.use(RequestInterceptor, error => {
    return Promise.reject(error);
});

MainRequest.interceptors.response.use(
    response => response,
    ResponseInterceptor
);

export interface CurrentDate {
    today: string;
    theWeek: string;
    batchName: string;
    batchNo: string;
    endDate: string;
    startDate: string;
}

/**
 * 获取当前日期和当前周
 */
export function getCurrentDate() {
    const token = getToken();
    return axios
        .get<SuccessData<CurrentDate>>("teacher/currentDate", {
            headers: { token }
        })
        .then(res => res.data.data);
}

export enum StudentType {
    BenKeSheng = "1", // 本科
    YanJiuSheng = "2", // 研究生
    KuaJing = "3", // 跨境
    GaoZhi = "4", // 高职
    MBA = "5", // MBA
    BoShi = "6", // 博士
    GuoJi = "7" // 国际教育
}

export enum workState {
    NoHomework = "0", // 未留
    HaveHomework = "1", // 已留
    HarfMark = "2", // 待批改
    MarkAll = "3" // 已批改
}

export enum liveState {
    NoIsLive = "0",
    IsLive = "1"
}

export enum Can {
    no,
    yes
}

export interface CourseItem {
    batchNo?: string;
    courseId: string;
    date: string;
    month: string;
    week: string;
    day: string;
    type: StudentType;
    courseUniqueId: string;
    courseName: string;
    className: string;
    chapterId: string;
    courseNo: string;
    section: string; //
    continunity: string;
    isPublish: BooleanValue;
    isLive: liveState;
    channelId: string;
    lmsCourseNo: string;
    // timeRange: readonly [string, string];
    courseSeq: string;
    platformType: string;
    isOpen: BooleanValue;
    readOnly?: BooleanValue;
    courseUrl: string; // 外部平台地址
    workstate: workState;
    weekTimeId: number;
    address: string;
    isCloud: liveState; //判断当前是否是实验课
    beginTime: string;
    endTime: string;
    key: number;

    teacherName?: string;
}

/**
 * 获取排课数据
 */
//http://172.16.30.51:3000/project/35/interface/api/6054
export interface getCourseProps {
    name?: string;
    evaluationFlag?: BooleanValue; //是否是同行评价
}
export function getCourseData(data: getCourseProps) {
    const token = getToken();

    return axios
        .post<SuccessData<CourseItem[]>>(
            "teacher/queryCourseList",
            qs.stringify(data),
            {
                headers: { token }
            }
        )
        .then(res => res.data.data)
        .then(data =>
            data.map((item, index) => {
                item.courseUniqueId = `${item.courseNo}-${item.courseSeq}`;
                item.key = index;
                return item;
            })
        );
}

export interface TeacherInfo {
    id: number;
    name: string;
    cardid: string;
    department: string;
    teacherno: string;
    pwd: string;
    loginname: string;
}

/**
 * 获取教师信息
 */
export async function getTeacherInfo(): Promise<TeacherInfo> {
    const storageKey = "teacherInfo";
    const teacherInfo = Storage.get<TeacherInfo>(storageKey);
    if (teacherInfo) return Promise.resolve(teacherInfo);

    const token = getToken();
    const data = await axios
        .get<SuccessData<TeacherInfo>>("teacher/getTeacherInfo", {
            headers: { token }
        })
        .then(res => res.data.data);
    Storage.set(storageKey, data);
    return data;
}

export interface TeacherCourse {
    courseNo: string;
    courseSeq: string;
    courseUniqueId: string;
    courseName: string;
    lmsCourseNo: string;
}

/**
 * 获取教师课程列表
 */
export function getTeacherCourse(): Promise<TeacherCourse[]> {
    const token = getToken();
    return axios
        .post<SuccessData<{ [key: string]: string }>>(
            "teacher/getTeacherCourse",
            "",
            { headers: { token } }
        )
        .then(res => res.data.data)
        .then(data =>
            _.map(data, (item, key) => ({
                courseNo: key.substr(2, key.length - 4),
                courseSeq: key.substr(-2, 2),
                courseUniqueId: key.substr(2),
                lmsCourseNo: key,
                courseName: item
            }))
        );
}
/**
 * 获取教师课程列表 作业专用
 */
export function getTeacherCourse2(): Promise<TeacherCourse[]> {
    const token = getToken();
    return axios
        .post<SuccessData<{ [key: string]: string }>>(
            "teacher/getTeacherCourse2",
            "",
            { headers: { token } }
        )
        .then(res => res.data.data)
        .then(data =>
            _.map(data, (item, key) => ({
                courseNo: key.substr(2, key.length - 4),
                courseSeq: key.substr(-2, 2),
                courseUniqueId: key.substr(2),
                lmsCourseNo: key,
                courseName: item
            }))
        );
}

interface QuestionItem {
    tid: string;
    pid: string;
    title: string;
    name: string;
    className: string;
    addtime: string;
    state: string;
}

/**
 * 获取论坛数据
 * @param cvs
 * @param ps
 */
export function getDufeTea(cvs: string, ps: number = 99999) {
    const token = getToken();
    const page = 1;
    return axios
        .post<SuccessData<QuestionItem[]>>(
            `/teacher/getDufeTea`,
            qs.stringify({ cvs, ps, page }),
            { headers: { token } }
        )
        .then(res => res.data);
}

/**
 * 论坛回复问题
 * @param title
 * @param content
 * @param tid
 */
export function replyQuestion(title: string, content: string, tid: string) {
    const token = getToken();
    return axios.post<SuccessData<null>>(
        `/teacher/reply`,
        qs.stringify({ title, content, tid }),
        { headers: { token } }
    );
}

interface IQuestionInfo {
    pid: string;
    tid: string;
    title: string;
    istopic: string;
    name: string;
    content: string;
    addtime: string;
}

/**
 * 获取问答详情
 * @param tid
 */
export function getTidDufe(tid: string) {
    const token = getToken();
    return axios.post<SuccessData<IQuestionInfo[]>>(
        `/teacher/getTidDufe`,
        qs.stringify({ tid }),
        { headers: { token } }
    );
}

/**
 * 保存授课平台地址
 */
export function updatePlatformUrl({
    courseNo,
    courseSeq,
    courseUrl,
    platformTypeName
}: {
    courseNo: string;
    courseSeq: string;
    courseUrl: string;
    platformTypeName: string;
}) {
    const token = getToken();
    return axios.post(
        `teacher/coursePlan/updatePlatformUrl`,
        qs.stringify({ courseNo, courseSeq, courseUrl, platformTypeName }),
        { headers: { token } }
    );
}

export interface CourseItemDashBoard {
    course: string;
    courseUrl: string;
    lmsCourseNo: string;
    platformType: string;
    section: string;
    type: StudentType;
    isLive: BooleanValue;
    channel: string;
    teacherId: string;
    teacher: string;
    name: string;
    seq: string;
    liveUrl: string;
    continunity: string;
}

/**
 * 获取某一日,某一节的全部排课信息
 */
export function getCoursePlanData(
    time: string,
    section: number = 0,
    continunity: number = 0
) {
    let sectionRange;
    if (section !== 0) sectionRange = `${section}-${section + continunity - 1}`;
    const request = axios.create();
    const customerCode = Config.CustomCode;
    const batchNo = Storage.get("batch") || Config.DefaultBatch;
    return request
        .post<SuccessData<CourseItemDashBoard[]>>(
            `teacher/coursePlan/getCourseData?${qs.stringify({
                time,
                sectionRange,
                customerCode
            })}`,
            {},
            { headers: { batchNo } }
        )
        .then(res => res.data.data)
        .then(data =>
            data.sort((itemA, itemB) => (itemA.platformType === "1" ? -1 : 1))
        );
}

/**
 * 取token
 */
export function getToken() {
    return Storage.get<string>("token");
}

/**
 * 把第几节课转成时间范围
 * @param section
 * @param continunity
 * @param type
 */
export function getTimeRangFromSection(
    section: number,
    continunity: number,
    type: StudentType
) {
    // 本科生
    const sections1 = [
        ["8:00", "8:50"],
        ["9:00", "9:50"],
        ["10:10", "11:00"],
        ["11:10", "12:00"],
        ["13:30", "14:20"],
        ["14:30", "15:20"],
        ["15:40", "16:30"],
        ["16:40", "17:30"],
        ["18:30", "19:20"],
        ["19:30", "20:20"],
        ["20:30", "21:20"],
        ["21:30", "22:20"]
    ];

    // 研究生
    const sections2 = [
        ["8:00", "8:50"],
        ["9:00", "9:50"],
        ["10:10", "11:00"],
        ["11:10", "12:00"],
        ["13:30", "14:20"],
        ["14:30", "15:20"],
        ["15:40", "16:30"],
        ["16:40", "17:30"],
        ["18:00", "18:50"],
        ["19:00", "19:50"],
        ["20:00", "20:50"],
        ["21:00", "21:50"],
        ["22:00", "22:50"],
        ["23:00", "23:50"]
    ];

    // 本科生新课表
    const sections3 = [
        ["8:00", "8:45"],
        ["8:50", "9:35"],
        ["9:55", "10:40"],
        ["10:45", "11:30"],
        ["13:00", "13:45"],
        ["13:50", "14:35"],
        ["14:40", "15:25"],
        ["18:15", "19:00"],
        ["19:05", "19:50"],
        ["19:55", "20:40"],
        ["20:45", "21:30"],
        ["22:00", "22:45"]
    ];

    // 研究生新课表
    const sections4 = [
        ["8:00", "8:45"],
        ["8:50", "9:35"],
        ["9:55", "10:40"],
        ["10:45", "11:30"],
        ["13:00", "13:45"],
        ["13:50", "14:35"],
        ["14:40", "15:25"],
        ["15:45", "16:45"],
        ["18:15", "19:00"],
        ["19:05", "19:50"],
        ["19:55", "20:40"],
        ["20:45", "21:30"],
        ["22:00", "22:45"]
    ];

    // MBA新课表
    const sections5 = [
        ["8:30", "9:10"],
        ["9:20", "10:00"],
        ["10:10", "10:50"],
        ["11:00", "11:50"],
        ["13:00", "13:40"],
        ["13:50", "14:30"],
        ["14:40", "15:20"],
        ["15:30", "16:20"],
        ["18:00", "18:40"],
        ["18:50", "19:30"],
        ["19:40", "21:20"]
    ];

    let sections = [StudentType.BoShi].includes(type) ? sections2 : sections1;
    if (type === StudentType.BenKeSheng) sections = sections3; // 本科生新课表
    if (type === StudentType.YanJiuSheng) sections = sections4; // 研究生新课表
    if (type === StudentType.KuaJing) sections = sections3; // 跨境跟本科一样
    if (type === StudentType.MBA) sections = sections5; // 跨境跟本科一样

    const startSection = section - 1;
    const endSection = section + continunity - 2;

    return [sections[startSection][0], sections[endSection][1]] as const;
}

/**
 * 按照日期过滤数据
 * @param data
 * @param date
 */
export function filterDate(data: CourseItem[], date: string): CourseItem[] {
    return _.sortBy(
        _.filter(data, item => {
            return item.date === date;
        }),
        item => item.section
    );
}

/**
 * 选择当前周的课程
 */
export function filterCourseByWeek(data: CourseItem[], week: number) {
    return _.groupBy(
        _.filter(data, item => item.week === String(week)),
        item => item.date
    );
}

/**
 * 选择当前课程的所有安排
 */
export function filterCourseByCourseUniqueId(
    data: CourseItem[],
    courseUniqueId: string
) {
    return _.filter(data, item => item.courseUniqueId === courseUniqueId);
}

/**
 * 获取所有的课程
 * @param data
 */
export function allCourses(data: CourseItem[]) {
    return _.map(
        _.groupBy(data, item => item.courseUniqueId),
        item => ({
            courseNo: item[0].courseNo,
            courseName: item[0].courseName,
            courseSeq: item[0].courseSeq,
            courseUniqueId: item[0].courseUniqueId
        })
    );
}

/**
 * 截取标题
 * @param title
 * @param len
 */
export function trimTitle(title: string, len: number) {
    if (title.length <= len) return title;
    return title.substr(0, len) + "...";
}

/**
 * 根据课程ID查找课程信息
 * @param data
 * @param courseUniqueId
 */
export function findCourseByCourseUniqueId(
    data: CourseItem[],
    courseUniqueId: string
): CourseItem {
    return _.find(data, { courseUniqueId })!;
}

/**
 * 获取课程的周
 * @param data
 * @param courseUniqueId
 */
export function getCourseWeeks(data: CourseItem[], courseUniqueId: string) {
    return _.map(
        _.groupBy(
            filterCourseByCourseUniqueId(data, courseUniqueId),
            item => item.week
        ),
        item => parseInt(item[0].week) || 1
    );
}

/**
 * 用课程编号获取课程名
 * @param courseNo
 * @param courseSeq
 */
export function getCourseNameByCourseNo(courseNo: string, courseSeq: string) {
    return getTeacherCourse().then(courses => {
        const course = _.find(
            courses,
            item => item.courseNo === courseNo && item.courseSeq === courseSeq
        );
        return course ? course.courseName : "";
    });
}

/**
 * 用课程编号获取课程名 作业专用
 * @param courseNo
 * @param courseSeq
 */
export function getCourseNameByCourseNo2(courseNo: string, courseSeq: string) {
    return getTeacherCourse2().then(courses => {
        const course = _.find(
            courses,
            item => item.courseNo === courseNo && item.courseSeq === courseSeq
        );
        return course ? course.courseName : "";
    });
}

/**
 * 从排课信息中获取课程信息, 如果排课信息未空则返回默认课程信息
 * @param item
 */

export interface SimpleCourseInfo {
    courseName: string;
    courseSeq: string;
    courseUrl: string;
    courseNo: string;
    isOpen: BooleanValue;
    platformType: string;
}

export function getCourseInfoFromItem(
    item: CourseItem | EmptyValue
): SimpleCourseInfo {
    return item
        ? { ...item }
        : {
              courseName: "全部课程",
              courseNo: "",
              courseSeq: "",
              platformType: "",
              isOpen: "1",
              courseUrl: ""
          };
}

/**
 * 数字转汉字
 */
export function number2Hanzi(num: number) {
    return [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
        "十一",
        "十二",
        "十三",
        "十四",
        "十五",
        "十六",
        "十七",
        "十八",
        "十九",
        "二十",
        "二十一",
        "二十二",
        "二十三",
        "二十四",
        "二十五",
        "二十六",
        "二十七",
        "二十八",
        "二十九",
        "三十",
        "三十一",
        "三十二",
        "三十三",
        "三十四",
        "三十五",
        "三十六",
        "三十七",
        "三十八",
        "三十九",
        "四十"
    ][num];
}

/**
 * 根据日期确定周几 (0 - 6)
 */
export function date2Week(date: string) {
    return moment(date).weekday();
}

export const WeeksName = [
    "周一",
    "周二",
    "周三",
    "周四",
    "周五",
    "周六",
    "周日"
];

/**
 * 根据星期确定周几(汉字)
 */
export function weekHanzi(week: number | string) {
    return WeeksName[toNumber(week) - 1];
}

/**
 * 根据日期确定周几(汉字)
 */
export function date2WeekHanzi(date: string) {
    return WeeksName[date2Week(date)];
}

/**
 * 获取节的描述 (第一节到第三节)
 * @param section
 * @param continunity
 */
export function sectionDescribe(section: string, continunity: string) {
    const num1 = Number(section);
    const num2 = Number(continunity);

    if (num2 === 1) return `第${number2Hanzi(num1)}节`;
    if (num2 === 2)
        return `第${number2Hanzi(num1)}、${number2Hanzi(num1 + 1)}节`;
    return `第${number2Hanzi(num1)}至${number2Hanzi(num1 + num2 - 1)}节`;
}

/**
 * 判断是否布尔真
 * @param value
 */
export function isTrue(value: BooleanValue): value is BooleanTrue {
    const TrueValueArray: any[] = [1, "1", true, "true", "True", "TRUE"];
    return TrueValueArray.includes(value);
}

export enum QuestionType {
    "DanXuan" = "1",
    "DuoXuan" = "2",
    "PanDuan" = "3",
    "ZhuGuan" = "4",
    "TianKong" = "5",
    "TingLi" = "6",
    "WanXingTianKong" = "7",
    "YueDuLiJie" = "8"
}

/**
 * 获取题目类型名
 */
export function getQuestionTypeName(type: QuestionType) {
    return [
        "",
        "单选题",
        "多选题",
        "判断题",
        "主观题",
        "填空题",
        "听力",
        "完形填空",
        "阅读理解"
    ][parseInt(type)];
}

/**
 * 获取平台名
 * @param type
 */
export function getPlatformName(type: string): string {
    switch (type) {
        case "1":
            return "白果云";
        default:
            return type || "未知平台";
    }
}

/**
 * 从错误对象中获取错误消息
 * @param e
 * @param defaultMessage
 */
export function errorMessage(e: any, defaultMessage: string = "发生未知错误") {
    if (!e) return defaultMessage + JSON.stringify(e || {});
    const errCodes = [400, 401];

    if (e.response && !errCodes.includes(e.response.status))
        return "数据请求失败";
    if (e.isAxiosError && e.message === "Network Error") return "网络异常";
    if (
        e.response &&
        errCodes.includes(e.response.status) &&
        e.response.data &&
        e.response.data.message
    )
        return e.response.data.message;
    if (e instanceof Error && e.message) return e.message;
    if (typeof e === "string") return e;
    return defaultMessage + JSON.stringify(e || {});
}

// 将各种类型的值转成数值类型
export function toNumber(value: number | string | null | undefined) {
    if (!value) return 0;
    return Number(value) || 0;
}

/**
 * 把数字/数字字符约去成对小数
 * @param value
 * @param decimal
 */
export function toFixedNumber(value: string | number, decimal: number = 1) {
    return parseFloat(toNumber(value).toFixed(decimal));
}

/**
 * 用指定大小的矩阵填充二维数组
 */
export function tableFill<T>(
    data: T[][],
    { rows, columns, fill }: { rows: number; columns: number; fill: T }
): T[][] {
    const data2: T[][] = [];

    for (let x = 0; x < rows; x++) {
        if (!data[x]) {
            data2[x] = new Array(columns).fill(fill);
            continue;
        }

        if (!data2[x]) {
            data2[x] = [];
        }

        for (let y = 0; y < columns; y++) {
            data2[x][y] = data[x][y] || fill;
        }
    }

    return data2;
}

/**
 * 二维数组行列互换
 */
export function tableTranspose<T>(data: T[][]) {
    let newTable: T[][] = [];
    if (!data[0]) return newTable;

    for (let x = 0; x < data[0].length; x++) {
        newTable[x] = [];

        for (let y = 0; y < data.length; y++) {
            newTable[x][y] = data[y][x];
        }
    }

    return newTable;
}

export interface classesStudent {
    index: number;
    studentId: string;
    studentNo: string;
    name: string;
    sex: string;
    subject: string;
    className: string;
    department: string;
}

/**
 * 获取班级学员
 * @param courseNo
 * @param courseSeq
 */
export function getStudents(courseNo: string, courseSeq: string) {
    const token = getToken();
    return axios
        .get<SuccessData<classesStudent[]>>("teacher/getStudents", {
            params: { courseNo, courseSeq },
            headers: { token }
        })
        .then(res => res.data.data);
}

//获取出题 题组排序
export enum SortType {
    HomeWork = "1",
    Exam = "2"
}
export function getTypeSort(type: SortType, paperId: number) {
    return axios
        .get<SuccessData<string>>("/teacher/getTypeSort", {
            params: { type, paperId }
        })
        .then(res => res.data.data);
}

export function downloadExcel(courseNo: string, courseSeq: string) {
    const token = getToken();
    const batchNo = Storage.get("batch") || Config.DefaultBatch;
    window.open(
        `${
            Config.ApiHost
        }teacher/downloadExcel?courseNo=${courseNo}&courseSeq=${courseSeq}&token=${btoa(
            token || ""
        )}&batchNo=${batchNo}`
    );
}

export interface SignItem {
    studentNo: string;
    studentName: string;
    signDate: string;
    signTime: {
        ids: string;
        time: string;
    }[];
}

/**
 * 获取签到列表
 * @param courseNo
 * @param courseSeq
 * @param section
 * @param week
 * @param weekTime
 */
export function getSignList(
    courseNo: string,
    courseSeq: string,
    section: string,
    week: string,
    weekTime: string
) {
    const token = getToken();
    return axios
        .get<SuccessData<SignItem[]>>("teacher/sign/getSignList", {
            params: { courseNo, courseSeq, section, week, weekTime },
            headers: { token }
        })
        .then(res => res.data.data);
}

/**
 * 取消签到
 * @param id
 */
export function cancelSign(id: string) {
    const token = getToken();
    return axios
        .post("teacher/sign/cancelSign", qs.stringify({ id }), {
            headers: { token }
        })
        .then(res => res.data.data);
}

/**
 * 补签
 * @param courseNo
 * @param courseSeq
 * @param section
 * @param week
 * @param weekTime
 * @param studentNo
 * @param time
 */
export function repairSign(
    courseNo: string,
    courseSeq: string,
    section: string,
    week: string,
    weekTime: string,
    studentNo: string,
    time: string
) {
    const token = getToken();
    return axios
        .post<SuccessData<string>>(
            "/teacher/sign/repairSign",
            qs.stringify({
                courseNo,
                courseSeq,
                section,
                week,
                weekTime,
                studentId: studentNo,
                signTime: time
            }),
            { headers: { token } }
        )
        .then(res => res.data.data);
}

export interface LivePaper {
    paperId: string;
    paperName: string;
    submitCount: string;
    score: string;
    averageScore: string;
    questionList: {
        questionId: string;
        type: "1" | "2" | "3";
        questionName: string;
        score: string;
        averageScore: string;
        optionList: {
            content: string;
            percen: string;
            count: string;
            right: string;
        }[];
        answerList: {
            answerId: string;
            studentNo: string;
            studentName: string;
            submitTime: string;
            answer: string;
            score: string;
        }[];
    }[];
}

export function getLivePaper(
    courseNo: string,
    courseSeq: string,
    section: string,
    week: string,
    weekTime: string
) {
    const token = getToken();
    return axios
        .get<SuccessData<LivePaper[]>>("teacher/livePaper/getLivePaper", {
            params: { courseNo, courseSeq, section, week, weekTime },
            headers: { token }
        })
        .then(res => res.data.data);
}

export function updateLive(
    questionId: string,
    answerId: string,
    score: number
) {
    const token = getToken();
    return axios
        .post(
            "teacher/livePaper/updateLive",
            qs.stringify({ questionId, answerId, score }),
            { headers: { token } }
        )
        .then(res => res.data.data);
}

export function exportSignList(
    courseNo: string,
    courseSeq: string,
    weekTime: string,
    week: string,
    section: string
) {
    const token = getToken();
    const batchNo = Storage.get("batch") || Config.DefaultBatch;
    window.open(
        `${Config.ApiHost}teacher/sign/exportSignList?token=${btoa(
            token || ""
        )}&courseNo=${courseNo}&courseSeq=${courseSeq}&weekTime=${weekTime}&week=${week}&section=${section}&batchNo=${batchNo}`
    );
}

export function syncSignList(channelId: string, date: string) {
    const request = axios.create();
    request
        .get("//data.edufe.com.cn/", {
            params: {
                f: "uaction",
                m: "same_qd_by_channel",
                cid: channelId,
                date: date
            }
        })
        .finally(() => window.location.reload());
}

export interface ExamCourseScoreItem {
    studentId: string;
    studentNo: string;
    studentName: string;
    signRecordCount: number;
    needSignRecourdCount: number;
    homeWork: string;
    examScore: string;
    dailyScore: string;
    resultScore: string;
}
/**
 * 获取班级学生成绩列表
 * @param courseNo
 * @param courseSeq
 */
export function getExamCourseScore(courseNo: string, courseSeq: string) {
    const token = getToken();
    return axios
        .get<
            SuccessData<{
                studentScore: ExamCourseScoreItem[];
                examScoreRate: string;
                dailyScoreRate: string;
            }>
        >("teacher/getExamCourseScore", {
            params: { courseNo, courseSeq },
            headers: { token }
        })
        .then(res => res.data.data);
}

/**
 * 保存学生平时成绩
 * @param courseNo
 * @param courseSeq
 * @param studentId
 * @param dailyScore
 */
export function saveStudentDailyScore(
    courseNo: string,
    courseSeq: string,
    studentId: string,
    dailyScore: number
) {
    const token = getToken();
    return axios
        .post(
            "teacher/saveStudentDailyScore",
            qs.stringify({ courseNo, courseSeq, studentId, dailyScore }),
            { headers: { token } }
        )
        .then(res => res.data.data);
}

/**
 * 合成成绩
 * @param courseNo
 * @param courseSeq
 * @param dailyScoreRate
 * @param examScoreRate
 */
export function setExamCourseScore(
    courseNo: string,
    courseSeq: string,
    dailyScoreRate: string,
    examScoreRate: string
) {
    const token = getToken();
    return axios
        .post(
            "teacher/setExamCourseScore",
            qs.stringify({
                courseNo,
                courseSeq,
                dailyScoreRate,
                examScoreRate
            }),
            { headers: { token } }
        )
        .then(res => res.data.data);
}

/**
 * 导出成绩
 * @param courseNo
 * @param courseSeq
 */
export function exportStudentScoreList(courseNo: string, courseSeq: string) {
    const token = getToken();
    const batchNo = Storage.get("batch") || Config.DefaultBatch;
    window.open(
        `${
            Config.ApiHost
        }teacher/exportStudentScoreList?courseNo=${courseNo}&courseSeq=${courseSeq}&token=${btoa(
            token || ""
        )}&batchNo=${batchNo}`
    );
}

/**
 * 获取七牛云上传token
 */
export function getQiniuUploadToken() {
    const token = getToken();
    return axios
        .post("/teacher/getUpToken", {}, { headers: { token } })
        .then(res => res.data);
}

interface UploadParams {
    onUploadProgress: (percent: number) => void;
}

/**
 * 上传到七牛
 */
export async function uploadToQiNiu(file: File, options?: UploadParams) {
    const request = axios.create();
    const token = await getQiniuUploadToken();
    const formData = new FormData();

    formData.append("file", file);
    formData.append("token", token.message);

    return request
        .post<{ hash: string; key: string }>(Config.QiNiuUploadUrl, formData, {
            headers: { "Content-Type": "multipart/form-data" }
        })
        .then(res => res.data)
        .then(data => ({
            key: data.key,
            name: file.name,
            url: `${Config.QiNiuDownloadUrl}/${
                data.key
            }?attname=${encodeURIComponent(file.name)}`
        }));
}

export interface UploadCourseWare {
    path: string;
    fileName: string;
    fileSize: string;
    downUrl: string;
    uploaded: "0" | "1";
    useType: "0" | "1"; // :0:web365  1：polyv
    orgFileName: string;
    uuid: string;
    fileType: string;
}

/**
 * 上传到七牛
 */
export async function uploadToCourseWare(
    weekTimeId: number,
    file: File,
    options?: UploadParams
) {
    checkCourseWare(file);

    const token = getToken();
    const headers = { "Content-Type": "multipart/form-data", token };
    const formData = new FormData();

    formData.append("importFiles", file);
    formData.append("weekTimeId", weekTimeId.toString());

    function onUploadProgress(progressEvent: any) {
        options?.onUploadProgress(
            (progressEvent.loaded * 100) / progressEvent.total
        );
    }

    return axios
        .post<SuccessData<UploadCourseWare[]>>(
            "/teacher/courseware/uploadCourseWareFile",
            formData,
            { headers, onUploadProgress }
        )
        .then(res => res.data.data[0]);
}

/**
 * 上传文件落库
 * @param weekTimeId
 * @param course
 */
export function saveCourseWareFile(
    weekTimeId: number,
    course: UploadCourseWare
) {
    const token = getToken();
    const courseWareFileStr = JSON.stringify([course]);
    const headers = { token };

    return axios
        .post<UploadCourseWare>(
            "/teacher/courseware/saveCourseWareFile",
            qs.stringify({ weekTimeId, courseWareFileStr }),
            { headers }
        )
        .then(res => res.data);
}

/**
 * 视频课件上传
 * @param weekTimeId
 * @param args
 */
export function uploadPolyvFile(
    weekTimeId: number,
    args: { vid: string; fileName: string; fileType: string; fileSize: number }
) {
    const token = getToken();
    const headers = { token };

    return axios
        .post<UploadCourseWare>(
            "/teacher/courseware/uploadPolyvFile",
            qs.stringify({ weekTimeId, ...args }),
            { headers }
        )
        .then(res => res.data);
}

/**
 * 上传到保利威
 */
export async function uploadToPolyV(file: File, options?: UploadParams) {
    checkCourseWare(file);

    const videoUpload = new PlvVideoUpload();

    await updatePolyUserData(videoUpload);
    const interval = setInterval(updatePolyUserData, 1000 * 60 * 2);

    const fileSetting = {
        // 文件上传相关信息设置
        title: file.name // 标题
    };

    return new Promise<string>((resolve, reject) => {
        videoUpload.addFile(
            file,
            {
                FileProgress: function (uploadInfo: any) {
                    options?.onUploadProgress(uploadInfo.progress * 100);
                },
                FileSucceed: function (uploadInfo: any) {
                    resolve(uploadInfo.fileData.vid);
                    clearInterval(interval);
                },
                FileFailed: function (uploadInfo: any) {
                    reject(uploadInfo.errData);
                    clearInterval(interval);
                }
            },
            fileSetting
        );

        videoUpload.startAll();
    });
}

/**
 * 返回polyv密钥
 */
function getPolyvKey() {
    const token = getToken();
    const headers = { token };

    return axios
        .get<SuccessData<{ sign: string; ptime: string; hash: string }>>(
            "/teacher/polyv/getPolyvKey",
            { headers }
        )
        .then(res => res.data.data);
}

/**
 * 更新保利威上传标识
 * @param videoUpload
 */
async function updatePolyUserData(videoUpload: any) {
    const userid = Config.PolyUid;
    const { ptime, sign, hash } = await getPolyvKey();

    return videoUpload.updateUserData({
        userid, // Polyv云点播账号的ID
        ptime, // 时间戳
        sign, // 是根据将secretkey和ts按照顺序拼凑起来的字符串进行MD5计算得到的值
        hash // 是根据将ts和writeToken按照顺序拼凑起来的字符串进行MD5计算得到的值
    });
}

/**
 * 校验上传文件
 * @param file
 * @param type
 */
export function checkCourseWare(
    file: File,
    type?: Record<keyof typeof CourseWareTypeList, string[]>
) {
    const accept = _.flatten(Object.values(type || CourseWareTypeList));
    const MaxFileSize = 1024 * 1024 * 1024; // 附件大小限制500M
    const ext = getExtName(file.name);

    // 校验文件名
    if (/[\\|/:?*<>]/.test(file.name)) {
        throw new Error(file.name + "文件名不能包含以下符号\\|/:?*<>以及\\0");
    }

    // 校验文件名长度
    if (file.name.length > 200) {
        throw new Error(file.name + "文件名不能超过200个字符");
    }

    // 校验文件类型
    if (!accept.includes(ext?.toLowerCase() || "")) {
        throw new Error(file.name + `该文件格式不允许上传`);
    }

    if (file.size > MaxFileSize) {
        throw new Error(
            file.name +
                `单个文件不能超过${humanFileSize(MaxFileSize)}, 上传失败`
        );
    }
}

export function checkCourseWareStr(
    file: File,
    type?: Record<keyof typeof CourseWareTypeList, string[]>
) {
    const accept = _.flatten(Object.values(type || CourseWareTypeList));
    const MaxFileSize = 1024 * 1024 * 1024; // 附件大小限制500M
    const ext = getExtName(file.name);

    // 校验文件名
    if (/[\\|/:?*<>]/.test(file.name)) {
        return {
            next: false,
            msg: file.name + "文件名不能包含以下符号\\|/:?*<>以及\\0"
        };
    }

    // 校验文件名长度
    if (file.name.length > 200) {
        return {
            next: false,
            msg: file.name + "文件名不能超过200个字符"
        };
    }

    // 校验文件类型
    if (!accept.includes(ext?.toLowerCase() || "")) {
        return {
            next: false,
            msg: file.name + `该文件格式不允许上传`
        };
    }

    if (file.size > MaxFileSize) {
        return {
            next: false,
            msg: `${file.name}单个文件不能超过${humanFileSize(
                MaxFileSize
            )}, 上传失败`
        };
    }

    return {
        next: true,
        msg: ""
    };
}

/**
 * 生成可读的文件尺寸(单位bytes)
 * @param bytes
 * @param si
 * @param dp
 */
export function humanFileSize(bytes: number, si = false, dp = 1) {
    const thresh = si ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
        return bytes + " B";
    }

    const units = si
        ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
        : ["K", "M", "G", "T", "P", "E", "Z", "Y"];
    let u = -1;
    const r = 10 ** dp;

    do {
        bytes /= thresh;
        ++u;
    } while (
        Math.round(Math.abs(bytes) * r) / r >= thresh &&
        u < units.length - 1
    );

    return bytes.toFixed(dp) + " " + units[u];
}

/**
 * 获取文件扩展名
 * @param filename
 */
export function getExtName(filename: string) {
    return filename.split(".").pop() || "";
}

/**
 * 保利下载地址
 * @param vid
 */
export function getPolyDownloadUrl(vid: string) {
    const d = vid.split("_")[0].substr(-1);
    return `http://mpv.videocc.net/${Config.PolyUid}/${d}/${vid}.mp4`;
}

/**
 * 获取学期名
 * @param batch
 */
export function getBatchName(batch: string) {
    const batchNo = toNumber(batch) - 2;
    const startYear = 2020 + Math.floor(batchNo / 2);
    const endYear = startYear + 1;
    const no = (batchNo % 2) + 1;
    const batchName = `${startYear}/${startYear + 1}(${no})`;
    return { startYear, endYear, no, batchName };
}

/**
 * 时间选择器---禁止点击传入时间之前的时间（时，分，秒）
 * @param times  传入的时间
 * @param index  索引
 */
export function getDisabledTimes(times: string, index: number) {
    const time = [];
    const timeArr = times.split(":");
    for (let i = 0; i < parseInt(timeArr[index]); i++) {
        time.push(i);
    }
    return time;
}

interface TermListItem {
    batchName: string; //学期名称
    batchNo: string; //学期编号
    beginDate: string;
    customerCode: string;
    dayOfWeek: number;
    endDate: string;
    id: string;
    isCurrentTerm: BooleanValue; //是否当前学期
    weekNo: number;
}

/**
 * 获取学期列表
 */

export function getTermList() {
    const token = getToken();
    const batch = Storage.get("batch");
    return axios
        .get<SuccessData<TermListItem[]>>("/teacher/term/getTermList", {
            headers: { token }
        })
        .then(res => res.data.data)
        .then(data => {
            const defaultBatch = data?.find((item: TermListItem) =>
                isTrue(item.isCurrentTerm)
            )?.batchNo;
            Storage.set("batch", batch || defaultBatch!);
            Storage.set("currentBatchNo", defaultBatch!);
            return data;
        });
}

export interface SysMessage {
    id: string;
    title: string;
    content: string;
    createUser: string;
    createTime: string;
}

/**
 * 获取消息通知
 */
export const getSysMessage = () => {
    return axios
        .post<SuccessData<SysMessage[]>>("/teacher/message/getSysMessage")
        .then(res => res.data.data);
};

/**
 * 首页系统消息已读
 * @param id
 */
export function readMessage(id: string) {
    return axios.post("/teacher/message/readMessage", qs.stringify({ id }));
}
